import {Component, Input} from "@angular/core";
import {VALUE_TYPE} from "../../enums/enums";
import {UI_TEXTS} from "../../enums/e-texts";
import {IQuestStage} from "../../interfaces/quest.definition";


@Component({
    selector: "nv-stage",
    templateUrl: "./nv-stage.component.html"
})


export class NvStageComponent {
  UI_TEXTS = UI_TEXTS;
  VAL_TYPES = VALUE_TYPE;

  @Input() document: IQuestStage;
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-stages/nv-stage.component.ts